import { useGlobalAlerts } from '../../contexts/AlertContext';
import { Ambulance, X, Activity } from 'lucide-react';

export function AlertOverlay() {
  const { activeAlerts, removeAlert } = useGlobalAlerts();

  if (activeAlerts.length === 0) return null;

  return (
    <div className="fixed top-20 right-6 z-[100] flex flex-col gap-3 pointer-events-none w-96 max-w-[calc(100vw-3rem)]">
      {activeAlerts.map((alert) => (
        <div 
          key={alert.id}
          className={`pointer-events-auto rounded-xl shadow-2xl border backdrop-blur-xl p-4 flex gap-4 animate-fade-in ${
            alert.type === 'ambulance' 
              ? 'bg-amber-500/20 border-amber-500/50 shadow-[0_0_20px_rgba(245,158,11,0.2)]'
              : 'bg-red-500/20 border-red-500/50 shadow-[0_0_20px_rgba(239,68,68,0.2)]'
          }`}
        >
          <div className="flex-shrink-0 mt-1">
            {alert.type === 'ambulance' ? (
              <div className="w-10 h-10 rounded-full bg-amber-500/20 flex items-center justify-center animate-pulse-slow border border-amber-500/30">
                <Ambulance className="w-5 h-5 text-amber-400" />
              </div>
            ) : (
              <div className="w-10 h-10 rounded-full bg-red-500/20 flex items-center justify-center animate-pulse-slow border border-red-500/30">
                <Activity className="w-5 h-5 text-red-400" />
              </div>
            )}
          </div>
          <div className="flex-1 min-w-0">
            <h4 className={`text-sm font-bold uppercase tracking-wider mb-1 truncate ${
              alert.type === 'ambulance' ? 'text-amber-400' : 'text-red-400'
            }`}>
              {alert.title}
            </h4>
            <p className="text-gray-200 text-sm">{alert.message}</p>
            {alert.metadata && alert.type === 'ambulance' && (
              <div className="mt-2 text-xs font-mono text-amber-200/70">
                ETA: {alert.metadata.eta} | Code: {alert.metadata.code}
              </div>
            )}
            {alert.metadata && alert.type === 'patient_critical' && (
              <div className="mt-2 text-xs font-mono text-red-200/70">
                Bed: {alert.metadata.bed} | MEWS: {alert.metadata.mews}
              </div>
            )}
          </div>
          <button 
            onClick={() => removeAlert(alert.id)}
            className="flex-shrink-0 text-white/50 hover:text-white transition-colors h-fit p-1 rounded hover:bg-white/10"
          >
            <X className="w-5 h-5" />
          </button>
        </div>
      ))}
    </div>
  );
}
